import { 
    FILIAL_DIVISION_GET_REQUEST, FILIAL_DIVISION_GET_SUCCESS, FILIAL_DIVISION_GET_ERROR, 
    FILIAL_DIVISION_GET_BY_KEY_REQUEST, FILIAL_DIVISION_GET_BY_KEY_SUCCESS, FILIAL_DIVISION_GET_BY_KEY_ERROR, 
    FILIAL_DIVISION_ADD_REQUEST, FILIAL_DIVISION_ADD_SUCCESS, FILIAL_DIVISION_ADD_ERROR, 
    FILIAL_DIVISION_EDIT_REQUEST, FILIAL_DIVISION_EDIT_SUCCESS, FILIAL_DIVISION_EDIT_ERROR, 
    FILIAL_DIVISION_DELETE_REQUEST, FILIAL_DIVISION_DELETE_SUCCESS, FILIAL_DIVISION_DELETE_ERROR
} from "../constants/filialDivisionConstants";

const initialState = {
    filialDivisions: [],
    filialDivision: {},
    loading: false,
    success: null,
    error: null,
    filialDivisionRequestedCount: 0,
};

export const filialDivisionReducer = (state = initialState, action) => {
    switch (action.type)     {
        case FILIAL_DIVISION_GET_REQUEST:
            return {
                ...state,
                filialDivisionRequestedCount: ++state.filialDivisionRequestedCount,
                loading: true,
            };
        case FILIAL_DIVISION_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                filialDivisions: action.payload,
                success: true,
            };
        case FILIAL_DIVISION_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case FILIAL_DIVISION_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FILIAL_DIVISION_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                filialDivision: action.payload,
                success: true,
            };
        case FILIAL_DIVISION_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case FILIAL_DIVISION_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FILIAL_DIVISION_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case FILIAL_DIVISION_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case FILIAL_DIVISION_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FILIAL_DIVISION_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case FILIAL_DIVISION_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case FILIAL_DIVISION_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FILIAL_DIVISION_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case FILIAL_DIVISION_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
